export const ORDER_STATE_LIVE = "live",
  ORDER_STATE_UNASSIGNED = "unassigned",
  ORDER_STATE_ASSIGNED = "assigned",
  ORDER_STATE_TRIP_CONFIRMED = "trip_confirmed",
  ORDER_STATE_REACHED_SHOP = "reached_shop",
  ORDER_STATE_SHIPPED = "shipped",
  ORDER_STATE_REACHED_DROP = "reached_drop",
  ORDER_STATE_PENDING_PICKUP = "pending_pickup",
  ORDER_STATE_TRIP_ASSIGNED = "trip_assigned";

export const ORDER_STATES = [ORDER_STATE_LIVE, ORDER_STATE_UNASSIGNED, ORDER_STATE_ASSIGNED, ORDER_STATE_TRIP_CONFIRMED,  ORDER_STATE_REACHED_SHOP, ORDER_STATE_SHIPPED, ORDER_STATE_REACHED_DROP];
